// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8dpxg","frase":"styles_frase__5ql09","sloganText":"styles_sloganText__kqEmy","avisoText":"styles_avisoText__-KmxD","body":"styles_body__Zy3JE"};